const fakeUpdate = (expiration) => ({
  lastActive,
}) => new Promise((resolve) => {
  resolve({
    expiration: lastActive + expiration,
  });
});

export default fakeUpdate;
